import React from 'react';
import Breadcrumbs from '@/widgets/breadcrumbs';
import '../../components/upiid-details/solicitation-upiid-details.scss';

import UpiidDetailsProvider from '../../components/upiid-details/upiid-details-provider';
import EditSolicitationContent from './edit-solicitation-content';
import { breadcrumbsPath } from '../../utils/solicitation-helpers';

const RenewSolicitation = () => {
  return (
    <>
      <Breadcrumbs current="Edit Solicitation" path={breadcrumbsPath} />
      <UpiidDetailsProvider>
        <EditSolicitationContent />
      </UpiidDetailsProvider>
    </>
  );
};

export default RenewSolicitation;
